import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, Mail, Instagram, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const produtos = [
    { nome: 'Orçamento na Hora', link: '/orcamento' },
    { nome: 'Agenda Cheia', link: '/agenda' },
    { nome: 'Meu Trampo', link: '/meutrampo' },
    { nome: 'ClienteJá', link: '/clienteja' },
    { nome: 'PostaJá', link: '/postaja' },
    { nome: 'AtivaJá Pro', link: '/pro' },
  ];

  const suporte = [
    { nome: 'Central de Ajuda', link: '#' },
    { nome: 'FAQ', link: '#' },
    { nome: 'Contato', link: '#' },
  ];

  const legal = [
    { nome: 'Termos de Uso', link: '#' },
    { nome: 'Política de Privacidade', link: '#' },
    { nome: 'Cookies', link: '#' },
  ];

  return (
    <footer className="bg-slate-900 text-slate-400">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                <span className="text-white font-bold text-lg">A</span>
              </div>
              <span className="text-xl font-bold text-white">AtivaJá</span>
            </div>
            <p className="text-slate-500 text-sm mb-6 max-w-xs">
              Automação para profissionais que querem crescer. 
              Transforme seu negócio com ferramentas simples e poderosas.
            </p>
            <div className="flex gap-3">
              <a 
                href="https://wa.me/5524993183242" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-green-600 flex items-center justify-center transition-colors"
              >
                <MessageCircle size={18} className="text-slate-400 hover:text-white" />
              </a>
              <a 
                href="mailto:contato@ativaja.com"
                className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-blue-600 flex items-center justify-center transition-colors"
              >
                <Mail size={18} className="text-slate-400 hover:text-white" />
              </a>
              <a 
                href="#"
                className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-pink-600 flex items-center justify-center transition-colors"
              >
                <Instagram size={18} className="text-slate-400 hover:text-white" />
              </a>
            </div>
          </div>

          {/* Produtos */}
          <div>
            <h4 className="text-white font-semibold mb-4">Produtos</h4>
            <ul className="space-y-3">
              {produtos.map((item, i) => (
                <li key={i}>
                  <button 
                    onClick={() => navigate(item.link)}
                    className="text-slate-500 hover:text-white text-sm transition-colors"
                  >
                    {item.nome}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Suporte */}
          <div>
            <h4 className="text-white font-semibold mb-4">Suporte</h4>
            <ul className="space-y-3">
              {suporte.map((item, i) => (
                <li key={i}>
                  <a 
                    href={item.link}
                    className="text-slate-500 hover:text-white text-sm transition-colors"
                  >
                    {item.nome}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-3">
              {legal.map((item, i) => (
                <li key={i}>
                  <a 
                    href={item.link}
                    className="text-slate-500 hover:text-white text-sm transition-colors"
                  >
                    {item.nome}
                  </a>
                </li>
              ))}
            </ul>
            
            {/* Contact Info */}
            <div className="mt-6 pt-6 border-t border-slate-800">
              <h4 className="text-white font-semibold mb-3">Contato</h4>
              <div className="space-y-2 text-sm">
                <a 
                  href="mailto:contato@ativaja.com"
                  className="flex items-center gap-2 text-slate-500 hover:text-white transition-colors"
                >
                  <Mail size={14} />
                  contato@ativaja.com
                </a>
                <a 
                  href="https://wa.me/5524993183242"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-slate-500 hover:text-white transition-colors"
                >
                  <Phone size={14} />
                  +55 24 99318-3242
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-slate-600">
              © {currentYear} AtivaJá. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-6 text-sm text-slate-600">
              <a href="#" className="hover:text-slate-400 transition-colors">Termos</a>
              <a href="#" className="hover:text-slate-400 transition-colors">Privacidade</a>
              <a href="#" className="hover:text-slate-400 transition-colors">Cookies</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
